module.exports = __webpack_public_path__ + "static/assets/634aeff2b06653c193e7355654479da5.svg";